module.exports = __webpack_public_path__ + "static/media/logo192.bd8a48f7.jpg";